<template>
  <div>
    
    <!-- Exibe o token -->
    <div :class="isInputError('token')" @click="removeError('token')">
      <strong class="title-medium mt-4">API Key</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
          <b-form-input id="input-token" :placeholder="`Informe o API Key do ${integration.name}`" class="form-input" v-model="token" :disabled="loading" @change="updateConnection" trim></b-form-input>
      </b-form-group>
      <span class="show-error">
          {{ showError('token') }}
      </span>
    </div>

    <!-- Exibe actions -->
    <div :class="isInputError('use_name_product')" @click="removeError('use_name_product')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Exibir nome do produto na Nota Fiscal?</strong>
      </div>
      <multiselect 
        v-model="use_name_product.value"
        :options="use_name_product.items" 
        :loading="use_name_product.loading"
        :disabled="use_name_product.block"
        :multiple="false" 
        :show-labels="false" 
        :searchable="false"
        class="new-style"
        placeholder="Digite para pesquisar"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('use_name_product') }}</span>
    </div>

    <!-- Exibe envio -->
    <div :class="isInputError('send_email')" @click="removeError('send_email')">
      <div class="clearfix mt-4">
        <strong class="title-medium float-left">Enviar email com a Nota Fiscal parar o cliente?</strong>
      </div>
      <multiselect 
        v-model="send_email.value"
        :options="send_email.items" 
        :loading="send_email.loading"
        :disabled="send_email.block"
        :multiple="false" 
        :show-labels="false" 
        :searchable="false"
        class="new-style"
        placeholder="Digite para pesquisar"
        track-by="name"
        label="name"
      >
        <template #option="props">
          <span class="d-flex option__item">{{ props.option.name }}</span>
        </template>
        <template #placeholder>
          <span class="select-title">Selecione a opção desejada</span>
        </template>
        <template #caret>
          <img src="@/assets/img/icons/multiselect-arrow.svg" class="multiselect__arrow" />
        </template>
      </multiselect>
      <span class="show-error">{{ showError('send_email') }}</span>
    </div>

    <!-- Exibe a URL webhook -->
    <div>
      <strong class="title-medium mt-4">Copie e adicione a url na configuração de webhook na NotaZZ</strong>
      <b-form-group id="fieldset-token" label-for="input-token">
          <b-form-input 
            id="url_webhook" 
            placeholder="URL Webhook" 
            class="form-input copy" 
            :value="url_webhook" 
            :readOnly="true"
            @click="copyValue('url_webhook')"
          ></b-form-input>
      </b-form-group>
      <span class="subinfo">Para receber o PDF de sua nota, é necessário adicionar esta URL nas configurações de webhook no NotaZZ.</span>
    </div>

    <!-- Botao Salvar -->
    <b-button class="btn-confirm mt-4" variant="primary" :disabled="loading || loadingSave" @click="saveItegration">
      <template v-if="loadingSave">
        <b-spinner variant="light" class="mr-2" small></b-spinner>
        {{ $t('views.seller.integrations.config.save.button.saving') }}
      </template>
      <template v-else>
        {{ $t('views.seller.integrations.config.save.button.save') }}
      </template>
    </b-button>

  </div>
</template>

<script>

import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import NoteCenterIntegration from "@/services/resources/NoteCenterIntegration";
import TokenService from "@/services/resources/TokenService";

export default {
  name: "IntegrationsConfigNotazz",
  components: {
    Multiselect
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    integration: {
      type: Object,
      required: true,
      default: () => ({ name: 'Notazz' })
    },
    mountInputError: {
      type: Function,
      required: true
    },
    isInputError: {
      type: Function,
      required: true
    },
    removeError: {
      type: Function,
      required: true
    },
    showError: {
      type: Function,
      required: true
    },
    fetchCallbacks: {
      type: Function,
      required: true
    },
  },
  data: () => {
    return {
      loadingSave: false,
      token: '',
      url_webhook: '',
      use_name_product: {
        block: true,
        loading: false,
        value: null,
        items: [
          {
            name: 'Sim, exibir nome do produto na nota fiscal',
            value: true
          },
          {
            name: 'Não, não exibir nome do produto na nota fiscal',
            value: false
          }
        ]
      },
      send_email: {
        block: true,
        loading: false,
        value: null,
        items: [
          {
            name: 'Sim, enviar email com a nota fiscal para o cliente',
            value: true
          },
          {
            name: 'Não, não enviar email com a nota fiscal para o cliente',
            value: false
          }
        ]
      }
    }
  },
  created() {
    this.getToken();
  },
  methods: {
    resetForm() {
      this.token = '';
      this.use_name_product.value = null;
      this.use_name_product.block = true;
      this.send_email.value = null;
      this.send_email.block = true;
    },
    copyValue(type) {
      const el = document.getElementById(type);
      el.select();
      document.execCommand("copy");
      this.messageSuccess('A Url foi copiada com sucesso', 'Copiado!');
    },
    setUrl(response) {
      this.url_webhook = `${process.env.VUE_APP_API_HOST}/api/retorno/notazz/?key=${response.api_key}`;
    },
    getToken() {
      TokenService.build().get('').then(response => {
        this.setUrl(response);
      });
    },
    messageSuccess(msg, title) {
      this.$bvToast.toast(msg, {
        variant: "success",
        title: title,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    updateConnection() {
      if(this.token) {
        this.use_name_product.block = false;
        this.send_email.block = false;
      }
    },
    saveItegration() {
      this.loadingSave = true;

      // Busca para ver se existe config salva
      NoteCenterIntegration.build().search({
        url: '/search/name/Notazz',
        name: 'Notazz'
      })
      .then(response => {
        if (response.config_integration) {
          this.confirmUpdate();
          return;
        }

        this.updateItegration();
      });
    },
    confirmUpdate() {
      Vue.swal({
        title: 'Integração já existente',
        html: `<p>Para substituir a integração atual, clique no botão abaixo.</p>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('views.seller.integrations.config.alert.update.ok'),
        cancelButtonText: 'Cancelar',
        customClass: "sweet-container-new",
        confirmButtonClass: "btn btn-primary text-nowrap",
        cancelButtonClass: "btn btn-outline-secondary text-nowrap",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.updateItegration();
        }
        else {
          this.loadingSave = false;
        }
      });
    },
    updateItegration() {
      NoteCenterIntegration.build().post('', {
        name: 'NotaZZ',
        config_integration: {
          token: this.token,
          use_name_product: this.use_name_product?.value?.value || false,
          send_email: this.send_email?.value?.value || false,
        },
        token: this.token,
        default: false
      }, { suppressErrorNotify: true })
      .then(() => {
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.success.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.success.title'),
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

        this.resetForm();
        this.fetchCallbacks();
      })
      .catch(error => {
        this.mountInputError(error.response.data);
        this.$bvToast.toast(this.$t('views.seller.integrations.config.toast.save.error.message'), {
          title: this.$t('views.seller.integrations.config.toast.save.error.title'),
          variant: "danger",
          autoHideDelay: 5000,
          appendToast: true,
        })
      })
      .finally(() => {
        this.loadingSave = false;
      });
    },
  }
}

</script>